import { faCancel, faClockRotateLeft, faEdit, faEllipsisVertical, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import cn from 'classnames';
import { updateEntry, deleteEntry } from '@redux/features/entriesSlice';
import { Button } from 'components/Button';
import { Modal } from 'components/Modal';
import styles from 'pages/Schedule/Actions/Actions.scss';

export const Actions = ({ className, entry, onEdit }) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const handleStatusChange = async (status) => {
    setIsOpen(false);
    await dispatch(updateEntry({ ...entry, status }));
  };

  const handleDelete = async () => {
    setIsConfirmOpen(false);
    setIsOpen(false);
    await dispatch(deleteEntry(entry.id));
  };

  const handleEdit = () => {
    const scrollEl = document.getElementById('page');
    if (scrollEl) {
      scrollEl.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setIsOpen(false);
    if (onEdit) {
      onEdit(entry);
    }
  };

  const isCancelled = entry.status === 'cancelled';

  return (
    <div className={cn(styles.actions, className)} onMouseLeave={() => setIsOpen(false)}>
      <Button className={styles.menuBtn} onClick={() => setIsOpen(true)} noStyle>
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </Button>
      <div className={cn(styles.modal, { [styles.open]: isOpen })}>
        <Button className={styles.actionBtn} onClick={handleEdit} noStyle>
          <FontAwesomeIcon className={styles.icon} icon={faEdit} />
          Редагувати
        </Button>
        <Button
          className={cn(styles.actionBtn, { [styles.cancelBtn]: !isCancelled })}
          onClick={() => handleStatusChange(isCancelled ? 'scheduled' : 'cancelled')}
          noStyle
        >
          <FontAwesomeIcon className={styles.icon} icon={isCancelled ? faClockRotateLeft : faCancel} />
          {isCancelled ? 'Відновити' : 'Скасувати'}
        </Button>
        <Button className={cn(styles.actionBtn, styles.deleteBtn)} onClick={() => setIsConfirmOpen(true)} noStyle>
          <FontAwesomeIcon className={styles.icon} icon={faTrash} />
          Видалити
        </Button>
      </div>
      <Modal className={styles.confirmModal} isOpen={isConfirmOpen} setIsOpen={setIsConfirmOpen}>
        <p>Ви впевнені, що хочете видалити запис?</p>
        <div className={styles.confirmButtons}>
          <Button onClick={handleDelete} className={cn(styles.confirmBtn, styles.yes)} noStyle>
            Так, видалити
          </Button>
          <Button onClick={() => setIsConfirmOpen(false)} className={cn(styles.confirmBtn, styles.no)} noStyle>
            Скасувати
          </Button>
        </div>
      </Modal>
    </div>
  );
};
